(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@huggg/bar-staff'), require('marked'), require('mobile-detect')) : typeof define === 'function' && define.amd ? define(['exports', '@huggg/bar-staff', 'marked', 'mobile-detect'], factory) : (global = global || self, factory(global.mapsBrowser = {}, global.barStaff, global.marked, global.MobileDetect));
})(this, function (exports, barStaff, marked, MobileDetect) {
  'use strict';

  marked = marked && Object.prototype.hasOwnProperty.call(marked, 'default') ? marked['default'] : marked;
  MobileDetect = MobileDetect && Object.prototype.hasOwnProperty.call(MobileDetect, 'default') ? MobileDetect['default'] : MobileDetect;
  function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
  }
  function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
  }
  function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [null];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
  }
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
  }
  function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e && _setPrototypeOf(t, e);
  }
  function _isNativeFunction(t) {
    try {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
      return "function" == typeof t;
    }
  }
  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
      return !!t;
    })();
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _possibleConstructorReturn(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
  }
  function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _typeof(o) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
  }
  function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function _wrapNativeSuper(t) {
      if (null === t || !_isNativeFunction(t)) return t;
      if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== r) {
        if (r.has(t)) return r.get(t);
        r.set(t, Wrapper);
      }
      function Wrapper() {
        return _construct(t, arguments, _getPrototypeOf(this).constructor);
      }
      return Wrapper.prototype = Object.create(t.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
  }
  var mapOptions = {
    center: {
      lat: 54.578206,
      lng: -3.879891
    },
    clickableIcons: false,
    disableDefaultUI: true,
    zoom: 4,
    minZoom: 4,
    styles: [{
      featureType: 'poi.business',
      stylers: [{
        visibility: 'off'
      }]
    }, {
      featureType: 'poi.park',
      elementType: 'labels.text',
      stylers: [{
        visibility: 'off'
      }]
    }]
  };
  var InvalidBoundsError = function (_Error) {
    function InvalidBoundsError() {
      _classCallCheck(this, InvalidBoundsError);
      return _callSuper(this, InvalidBoundsError, arguments);
    }
    _inherits(InvalidBoundsError, _Error);
    return _createClass(InvalidBoundsError);
  }(_wrapNativeSuper(Error));
  _defineProperty(InvalidBoundsError, "defaultMessage", 'Invalid bounds object supplied, [north, east, south, west] are required properties.');
  var InvalidCoordinatesError = function (_Error) {
    function InvalidCoordinatesError() {
      _classCallCheck(this, InvalidCoordinatesError);
      return _callSuper(this, InvalidCoordinatesError, arguments);
    }
    _inherits(InvalidCoordinatesError, _Error);
    return _createClass(InvalidCoordinatesError);
  }(_wrapNativeSuper(Error));
  _defineProperty(InvalidCoordinatesError, "defaultMessage", 'Invalid coordinates object supplied, [lat, lng] are required properties.');
  var InvalidLocationsError = function (_Error) {
    function InvalidLocationsError() {
      _classCallCheck(this, InvalidLocationsError);
      return _callSuper(this, InvalidLocationsError, arguments);
    }
    _inherits(InvalidLocationsError, _Error);
    return _createClass(InvalidLocationsError);
  }(_wrapNativeSuper(Error));
  _defineProperty(InvalidLocationsError, "defaultMessage", 'Invalid "locations" supplied. Locations must be an array with a ' + 'minimum of 0 items.');
  var InvalidBoundsError$1 = function (_Error) {
    function InvalidBoundsError() {
      _classCallCheck(this, InvalidBoundsError);
      return _callSuper(this, InvalidBoundsError, arguments);
    }
    _inherits(InvalidBoundsError, _Error);
    return _createClass(InvalidBoundsError);
  }(_wrapNativeSuper(Error));
  _defineProperty(InvalidBoundsError$1, "defaultMessage", 'Invalid event listener parameters provided, expected to receive "eventName" and "callback" parameters.');
  var InvalidMarkersError = function (_Error) {
    function InvalidMarkersError() {
      _classCallCheck(this, InvalidMarkersError);
      return _callSuper(this, InvalidMarkersError, arguments);
    }
    _inherits(InvalidMarkersError, _Error);
    return _createClass(InvalidMarkersError);
  }(_wrapNativeSuper(Error));
  _defineProperty(InvalidMarkersError, "defaultMessage", 'Invalid "markers" supplied. Markers must be an array with a ' + 'minimum of 0 items.');

  /**
   * @license
   * Licensed under the Apache License, Version 2.0 (the "License");
   * you may not use this file except in compliance with the License.
   * You may obtain a copy of the License at
   *
   *     http://www.apache.org/licenses/LICENSE-2.0
   *
   * Unless required by applicable law or agreed to in writing, software
   * distributed under the License is distributed on an "AS IS" BASIS,
   * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   * See the License for the specific language governing permissions and
   * limitations under the License.
   */
  function MarkerClusterer(map, opt_markers, opt_options) {
    this.extend(MarkerClusterer, google.maps.OverlayView);
    this.map_ = map;
    this.markers_ = [];
    this.clusters_ = [];
    this.sizes = [53, 56, 66, 78, 90];
    this.styles_ = [];
    this.ready_ = false;
    var options = opt_options || {};
    this.gridSize_ = options['gridSize'] || 60;
    this.minClusterSize_ = options['minimumClusterSize'] || 2;
    this.maxZoom_ = options['maxZoom'] || null;
    this.styles_ = options['styles'] || [];
    this.imagePath_ = options['imagePath'] || this.MARKER_CLUSTER_IMAGE_PATH_;
    this.imageExtension_ = options['imageExtension'] || this.MARKER_CLUSTER_IMAGE_EXTENSION_;
    this.zoomOnClick_ = true;
    if (options['zoomOnClick'] != undefined) {
      this.zoomOnClick_ = options['zoomOnClick'];
    }
    this.averageCenter_ = false;
    if (options['averageCenter'] != undefined) {
      this.averageCenter_ = options['averageCenter'];
    }
    this.setupStyles_();
    this.setMap(map);
    this.prevZoom_ = this.map_.getZoom();
    this.zoomChanged_ = false;
    var that = this;
    google.maps.event.addListener(this.map_, 'zoom_changed', function () {
      var zoom = that.map_.getZoom();
      var minZoom = that.map_.minZoom || 0;
      var maxZoom = Math.min(that.map_.maxZoom || 100, that.map_.mapTypes[that.map_.getMapTypeId()].maxZoom);
      zoom = Math.min(Math.max(zoom, minZoom), maxZoom);
      if (that.prevZoom_ != zoom) {
        that.prevZoom_ = zoom;
        that.zoomChanged_ = true;
      }
    });
    google.maps.event.addListener(this.map_, 'idle', function () {
      if (that.zoomChanged_) {
        that.resetViewport();
        that.zoomChanged_ = false;
      }
      that.redraw();
    });
    if (opt_markers && (opt_markers.length || Object.keys(opt_markers).length)) {
      this.addMarkers(opt_markers, false);
    }
  }
  MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_PATH_ = '../images/m';
  MarkerClusterer.prototype.MARKER_CLUSTER_IMAGE_EXTENSION_ = 'png';
  MarkerClusterer.prototype.extend = function (obj1, obj2) {
    return function (object) {
      for (var property in object.prototype) {
        this.prototype[property] = object.prototype[property];
      }
      return this;
    }.apply(obj1, [obj2]);
  };
  MarkerClusterer.prototype.onAdd = function () {
    this.setReady_(true);
  };
  MarkerClusterer.prototype.draw = function () {};
  MarkerClusterer.prototype.setupStyles_ = function () {
    if (this.styles_.length) {
      return;
    }
    for (var i = 0, size; size = this.sizes[i]; i++) {
      this.styles_.push({
        url: this.imagePath_ + (i + 1) + '.' + this.imageExtension_,
        height: size,
        width: size
      });
    }
  };
  MarkerClusterer.prototype.fitMapToMarkers = function () {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0, marker; marker = markers[i]; i++) {
      bounds.extend(marker.getPosition());
    }
    this.map_.fitBounds(bounds);
  };
  MarkerClusterer.prototype.setStyles = function (styles) {
    this.styles_ = styles;
  };
  MarkerClusterer.prototype.getStyles = function () {
    return this.styles_;
  };
  MarkerClusterer.prototype.isZoomOnClick = function () {
    return this.zoomOnClick_;
  };
  MarkerClusterer.prototype.isAverageCenter = function () {
    return this.averageCenter_;
  };
  MarkerClusterer.prototype.getMarkers = function () {
    return this.markers_;
  };
  MarkerClusterer.prototype.getTotalMarkers = function () {
    return this.markers_.length;
  };
  MarkerClusterer.prototype.setMaxZoom = function (maxZoom) {
    this.maxZoom_ = maxZoom;
  };
  MarkerClusterer.prototype.getMaxZoom = function () {
    return this.maxZoom_;
  };
  MarkerClusterer.prototype.calculator_ = function (markers, numStyles) {
    var index = 0;
    var count = markers.length;
    var dv = count;
    while (dv !== 0) {
      dv = parseInt(dv / 10, 10);
      index++;
    }
    index = Math.min(index, numStyles);
    return {
      text: count,
      index: index
    };
  };
  MarkerClusterer.prototype.setCalculator = function (calculator) {
    this.calculator_ = calculator;
  };
  MarkerClusterer.prototype.getCalculator = function () {
    return this.calculator_;
  };
  MarkerClusterer.prototype.addMarkers = function (markers, opt_nodraw) {
    if (markers.length) {
      for (var i = 0, marker; marker = markers[i]; i++) {
        this.pushMarkerTo_(marker);
      }
    } else if (Object.keys(markers).length) {
      for (var marker in markers) {
        this.pushMarkerTo_(markers[marker]);
      }
    }
    if (!opt_nodraw) {
      this.redraw();
    }
  };
  MarkerClusterer.prototype.pushMarkerTo_ = function (marker) {
    marker.isAdded = false;
    if (marker['draggable']) {
      var that = this;
      google.maps.event.addListener(marker, 'dragend', function () {
        marker.isAdded = false;
        that.repaint();
      });
    }
    this.markers_.push(marker);
  };
  MarkerClusterer.prototype.addMarker = function (marker, opt_nodraw) {
    this.pushMarkerTo_(marker);
    if (!opt_nodraw) {
      this.redraw();
    }
  };
  MarkerClusterer.prototype.removeMarker_ = function (marker) {
    var index = -1;
    if (this.markers_.indexOf) {
      index = this.markers_.indexOf(marker);
    } else {
      for (var i = 0, m; m = this.markers_[i]; i++) {
        if (m == marker) {
          index = i;
          break;
        }
      }
    }
    if (index == -1) {
      return false;
    }
    marker.setMap(null);
    this.markers_.splice(index, 1);
    return true;
  };
  MarkerClusterer.prototype.removeMarker = function (marker, opt_nodraw) {
    var removed = this.removeMarker_(marker);
    if (!opt_nodraw && removed) {
      this.resetViewport();
      this.redraw();
      return true;
    }
    return false;
  };
  MarkerClusterer.prototype.removeMarkers = function (markers, opt_nodraw) {
    var markersCopy = markers === this.getMarkers() ? markers.slice() : markers;
    var removed = false;
    for (var i = 0, marker; marker = markersCopy[i]; i++) {
      var r = this.removeMarker_(marker);
      removed = removed || r;
    }
    if (!opt_nodraw && removed) {
      this.resetViewport();
      this.redraw();
      return true;
    }
  };
  MarkerClusterer.prototype.setReady_ = function (ready) {
    if (!this.ready_) {
      this.ready_ = ready;
      this.createClusters_();
    }
  };
  MarkerClusterer.prototype.getTotalClusters = function () {
    return this.clusters_.length;
  };
  MarkerClusterer.prototype.getMap = function () {
    return this.map_;
  };
  MarkerClusterer.prototype.setMap = function (map) {
    this.map_ = map;
  };
  MarkerClusterer.prototype.getGridSize = function () {
    return this.gridSize_;
  };
  MarkerClusterer.prototype.setGridSize = function (size) {
    this.gridSize_ = size;
  };
  MarkerClusterer.prototype.getMinClusterSize = function () {
    return this.minClusterSize_;
  };
  MarkerClusterer.prototype.setMinClusterSize = function (size) {
    this.minClusterSize_ = size;
  };
  MarkerClusterer.prototype.getExtendedBounds = function (bounds) {
    var projection = this.getProjection();
    var tr = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
    var bl = new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng());
    var trPix = projection.fromLatLngToDivPixel(tr);
    trPix.x += this.gridSize_;
    trPix.y -= this.gridSize_;
    var blPix = projection.fromLatLngToDivPixel(bl);
    blPix.x -= this.gridSize_;
    blPix.y += this.gridSize_;
    var ne = projection.fromDivPixelToLatLng(trPix);
    var sw = projection.fromDivPixelToLatLng(blPix);
    bounds.extend(ne);
    bounds.extend(sw);
    return bounds;
  };
  MarkerClusterer.prototype.isMarkerInBounds_ = function (marker, bounds) {
    return bounds.contains(marker.getPosition());
  };
  MarkerClusterer.prototype.clearMarkers = function () {
    this.resetViewport(true);
    this.markers_ = [];
  };
  MarkerClusterer.prototype.resetViewport = function (opt_hide) {
    for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
      cluster.remove();
    }
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
      marker.isAdded = false;
      if (opt_hide) {
        marker.setMap(null);
      }
    }
    this.clusters_ = [];
  };
  MarkerClusterer.prototype.repaint = function () {
    var oldClusters = this.clusters_.slice();
    this.clusters_.length = 0;
    this.resetViewport();
    this.redraw();
    window$1.setTimeout(function () {
      for (var i = 0, cluster; cluster = oldClusters[i]; i++) {
        cluster.remove();
      }
    }, 0);
  };
  MarkerClusterer.prototype.redraw = function () {
    this.createClusters_();
  };
  MarkerClusterer.prototype.distanceBetweenPoints_ = function (p1, p2) {
    if (!p1 || !p2) {
      return 0;
    }
    var R = 6371;
    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  };
  MarkerClusterer.prototype.addToClosestCluster_ = function (marker) {
    var distance = 40000;
    var clusterToAddTo = null;
    var pos = marker.getPosition();
    for (var i = 0, cluster; cluster = this.clusters_[i]; i++) {
      var center = cluster.getCenter();
      if (center) {
        var d = this.distanceBetweenPoints_(center, marker.getPosition());
        if (d < distance) {
          distance = d;
          clusterToAddTo = cluster;
        }
      }
    }
    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
      clusterToAddTo.addMarker(marker);
    } else {
      var cluster = new Cluster(this);
      cluster.addMarker(marker);
      this.clusters_.push(cluster);
    }
  };
  MarkerClusterer.prototype.createClusters_ = function () {
    if (!this.ready_) {
      return;
    }
    var mapBounds = new google.maps.LatLngBounds(this.map_.getBounds().getSouthWest(), this.map_.getBounds().getNorthEast());
    var bounds = this.getExtendedBounds(mapBounds);
    for (var i = 0, marker; marker = this.markers_[i]; i++) {
      if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
        this.addToClosestCluster_(marker);
      }
    }
  };
  function Cluster(markerClusterer) {
    this.markerClusterer_ = markerClusterer;
    this.map_ = markerClusterer.getMap();
    this.gridSize_ = markerClusterer.getGridSize();
    this.minClusterSize_ = markerClusterer.getMinClusterSize();
    this.averageCenter_ = markerClusterer.isAverageCenter();
    this.center_ = null;
    this.markers_ = [];
    this.bounds_ = null;
    this.clusterIcon_ = new ClusterIcon(this, markerClusterer.getStyles(), markerClusterer.getGridSize());
  }
  Cluster.prototype.isMarkerAlreadyAdded = function (marker) {
    if (this.markers_.indexOf) {
      return this.markers_.indexOf(marker) != -1;
    }
    for (var i = 0, m; m = this.markers_[i]; i++) {
      if (m == marker) {
        return true;
      }
    }
    return false;
  };
  Cluster.prototype.addMarker = function (marker) {
    if (this.isMarkerAlreadyAdded(marker)) {
      return false;
    }
    if (!this.center_) {
      this.center_ = marker.getPosition();
      this.calculateBounds_();
    } else if (this.averageCenter_) {
      var l = this.markers_.length + 1;
      var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
      var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
      this.center_ = new google.maps.LatLng(lat, lng);
      this.calculateBounds_();
    }
    marker.isAdded = true;
    this.markers_.push(marker);
    var len = this.markers_.length;
    if (len < this.minClusterSize_ && marker.getMap() != this.map_) {
      marker.setMap(this.map_);
    }
    if (len == this.minClusterSize_) {
      for (var i = 0; i < len; i++) {
        this.markers_[i].setMap(null);
      }
    }
    if (len >= this.minClusterSize_) {
      marker.setMap(null);
    }
    this.updateIcon();
    return true;
  };
  Cluster.prototype.getMarkerClusterer = function () {
    return this.markerClusterer_;
  };
  Cluster.prototype.getBounds = function () {
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    var markers = this.getMarkers();
    for (var i = 0, marker; marker = markers[i]; i++) {
      bounds.extend(marker.getPosition());
    }
    return bounds;
  };
  Cluster.prototype.remove = function () {
    this.clusterIcon_.remove();
    this.markers_.length = 0;
    delete this.markers_;
  };
  Cluster.prototype.getSize = function () {
    return this.markers_.length;
  };
  Cluster.prototype.getMarkers = function () {
    return this.markers_;
  };
  Cluster.prototype.getCenter = function () {
    return this.center_;
  };
  Cluster.prototype.calculateBounds_ = function () {
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
  };
  Cluster.prototype.isMarkerInClusterBounds = function (marker) {
    return this.bounds_.contains(marker.getPosition());
  };
  Cluster.prototype.getMap = function () {
    return this.map_;
  };
  Cluster.prototype.updateIcon = function () {
    var zoom = this.map_.getZoom();
    var mz = this.markerClusterer_.getMaxZoom();
    if (mz && zoom > mz) {
      for (var i = 0, marker; marker = this.markers_[i]; i++) {
        marker.setMap(this.map_);
      }
      return;
    }
    if (this.markers_.length < this.minClusterSize_) {
      this.clusterIcon_.hide();
      return;
    }
    var numStyles = this.markerClusterer_.getStyles().length;
    var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
    this.clusterIcon_.setCenter(this.center_);
    this.clusterIcon_.setSums(sums);
    this.clusterIcon_.show();
  };
  function ClusterIcon(cluster, styles, opt_padding) {
    cluster.getMarkerClusterer().extend(ClusterIcon, google.maps.OverlayView);
    this.styles_ = styles;
    this.padding_ = opt_padding || 0;
    this.cluster_ = cluster;
    this.center_ = null;
    this.map_ = cluster.getMap();
    this.div_ = null;
    this.sums_ = null;
    this.visible_ = false;
    this.setMap(this.map_);
  }
  ClusterIcon.prototype.triggerClusterClick = function () {
    var markerClusterer = this.cluster_.getMarkerClusterer();
    google.maps.event.trigger(markerClusterer.map_, 'clusterclick', this.cluster_);
    if (markerClusterer.isZoomOnClick()) {
      this.map_.fitBounds(this.cluster_.getBounds());
    }
  };
  ClusterIcon.prototype.onAdd = function () {
    this.div_ = document.createElement('DIV');
    if (this.visible_) {
      var pos = this.getPosFromLatLng_(this.center_);
      this.div_.style.cssText = this.createCss(pos);
      this.div_.innerHTML = this.sums_.text;
    }
    var panes = this.getPanes();
    panes.overlayMouseTarget.appendChild(this.div_);
    var that = this;
    google.maps.event.addDomListener(this.div_, 'click', function () {
      that.triggerClusterClick();
    });
  };
  ClusterIcon.prototype.getPosFromLatLng_ = function (latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    pos.x -= parseInt(this.width_ / 2, 10);
    pos.y -= parseInt(this.height_ / 2, 10);
    return pos;
  };
  ClusterIcon.prototype.draw = function () {
    if (this.visible_) {
      var pos = this.getPosFromLatLng_(this.center_);
      this.div_.style.top = pos.y + 'px';
      this.div_.style.left = pos.x + 'px';
      this.div_.style.zIndex = google.maps.Marker.MAX_ZINDEX + 1;
    }
  };
  ClusterIcon.prototype.hide = function () {
    if (this.div_) {
      this.div_.style.display = 'none';
    }
    this.visible_ = false;
  };
  ClusterIcon.prototype.show = function () {
    if (this.div_) {
      var pos = this.getPosFromLatLng_(this.center_);
      this.div_.style.cssText = this.createCss(pos);
      this.div_.style.display = '';
    }
    this.visible_ = true;
  };
  ClusterIcon.prototype.remove = function () {
    this.setMap(null);
  };
  ClusterIcon.prototype.onRemove = function () {
    if (this.div_ && this.div_.parentNode) {
      this.hide();
      this.div_.parentNode.removeChild(this.div_);
      this.div_ = null;
    }
  };
  ClusterIcon.prototype.setSums = function (sums) {
    this.sums_ = sums;
    this.text_ = sums.text;
    this.index_ = sums.index;
    if (this.div_) {
      this.div_.innerHTML = sums.text;
    }
    this.useStyle();
  };
  ClusterIcon.prototype.useStyle = function () {
    var index = Math.max(0, this.sums_.index - 1);
    index = Math.min(this.styles_.length - 1, index);
    var style = this.styles_[index];
    this.url_ = style['url'];
    this.height_ = style['height'];
    this.width_ = style['width'];
    this.textColor_ = style['textColor'];
    this.anchor_ = style['anchor'];
    this.textSize_ = style['textSize'];
    this.backgroundPosition_ = style['backgroundPosition'];
  };
  ClusterIcon.prototype.setCenter = function (center) {
    this.center_ = center;
  };
  ClusterIcon.prototype.createCss = function (pos) {
    var style = [];
    style.push('background-image:url(' + this.url_ + ');');
    var backgroundPosition = this.backgroundPosition_ ? this.backgroundPosition_ : '0 0';
    style.push('background-position:' + backgroundPosition + ';');
    if (_typeof(this.anchor_) === 'object') {
      if (typeof this.anchor_[0] === 'number' && this.anchor_[0] > 0 && this.anchor_[0] < this.height_) {
        style.push('height:' + (this.height_ - this.anchor_[0]) + 'px; padding-top:' + this.anchor_[0] + 'px;');
      } else {
        style.push('height:' + this.height_ + 'px; line-height:' + this.height_ + 'px;');
      }
      if (typeof this.anchor_[1] === 'number' && this.anchor_[1] > 0 && this.anchor_[1] < this.width_) {
        style.push('width:' + (this.width_ - this.anchor_[1]) + 'px; padding-left:' + this.anchor_[1] + 'px;');
      } else {
        style.push('width:' + this.width_ + 'px; text-align:center;');
      }
    } else {
      style.push('height:' + this.height_ + 'px; line-height:' + this.height_ + 'px; width:' + this.width_ + 'px; text-align:center;');
    }
    var txtColor = this.textColor_ ? this.textColor_ : 'black';
    var txtSize = this.textSize_ ? this.textSize_ : 11;
    style.push('cursor:pointer; top:' + pos.y + 'px; left:' + pos.x + 'px; color:' + txtColor + '; position:absolute; font-size:' + txtSize + 'px; font-family:Arial,sans-serif; font-weight:bold');
    return style.join('');
  };
  var window$1 = window$1 || {};
  window$1['MarkerClusterer'] = MarkerClusterer;
  MarkerClusterer.prototype['addMarker'] = MarkerClusterer.prototype.addMarker;
  MarkerClusterer.prototype['addMarkers'] = MarkerClusterer.prototype.addMarkers;
  MarkerClusterer.prototype['clearMarkers'] = MarkerClusterer.prototype.clearMarkers;
  MarkerClusterer.prototype['fitMapToMarkers'] = MarkerClusterer.prototype.fitMapToMarkers;
  MarkerClusterer.prototype['getCalculator'] = MarkerClusterer.prototype.getCalculator;
  MarkerClusterer.prototype['getGridSize'] = MarkerClusterer.prototype.getGridSize;
  MarkerClusterer.prototype['getExtendedBounds'] = MarkerClusterer.prototype.getExtendedBounds;
  MarkerClusterer.prototype['getMap'] = MarkerClusterer.prototype.getMap;
  MarkerClusterer.prototype['getMarkers'] = MarkerClusterer.prototype.getMarkers;
  MarkerClusterer.prototype['getMaxZoom'] = MarkerClusterer.prototype.getMaxZoom;
  MarkerClusterer.prototype['getStyles'] = MarkerClusterer.prototype.getStyles;
  MarkerClusterer.prototype['getTotalClusters'] = MarkerClusterer.prototype.getTotalClusters;
  MarkerClusterer.prototype['getTotalMarkers'] = MarkerClusterer.prototype.getTotalMarkers;
  MarkerClusterer.prototype['redraw'] = MarkerClusterer.prototype.redraw;
  MarkerClusterer.prototype['removeMarker'] = MarkerClusterer.prototype.removeMarker;
  MarkerClusterer.prototype['removeMarkers'] = MarkerClusterer.prototype.removeMarkers;
  MarkerClusterer.prototype['resetViewport'] = MarkerClusterer.prototype.resetViewport;
  MarkerClusterer.prototype['repaint'] = MarkerClusterer.prototype.repaint;
  MarkerClusterer.prototype['setCalculator'] = MarkerClusterer.prototype.setCalculator;
  MarkerClusterer.prototype['setGridSize'] = MarkerClusterer.prototype.setGridSize;
  MarkerClusterer.prototype['setMaxZoom'] = MarkerClusterer.prototype.setMaxZoom;
  MarkerClusterer.prototype['onAdd'] = MarkerClusterer.prototype.onAdd;
  MarkerClusterer.prototype['draw'] = MarkerClusterer.prototype.draw;
  Cluster.prototype['getCenter'] = Cluster.prototype.getCenter;
  Cluster.prototype['getSize'] = Cluster.prototype.getSize;
  Cluster.prototype['getMarkers'] = Cluster.prototype.getMarkers;
  ClusterIcon.prototype['onAdd'] = ClusterIcon.prototype.onAdd;
  ClusterIcon.prototype['draw'] = ClusterIcon.prototype.draw;
  ClusterIcon.prototype['onRemove'] = ClusterIcon.prototype.onRemove;
  Object.keys = Object.keys || function (o) {
    var result = [];
    for (var name in o) {
      if (o.hasOwnProperty(name)) result.push(name);
    }
    return result;
  };
  var clusterOptions = {
    imagePath: 'https://cdn.huggg.me/maps',
    gridSize: 30,
    minimumClusterSize: 3,
    averageCenter: true,
    styles: [{
      url: 'https://cdn.huggg.me/maps/cluster1.png',
      height: 55,
      width: 56,
      textColor: '#ffffff',
      textSize: 13
    }, {
      url: 'https://cdn.huggg.me/maps/cluster1.png',
      height: 55,
      width: 56,
      textColor: '#ffffff',
      textSize: 13
    }, {
      url: 'https://cdn.huggg.me/maps/cluster2.png',
      height: 89,
      width: 90,
      textColor: '#ffffff',
      textSize: 13
    }]
  };
  var appConfig = {
    huggg_hq: {
      lat: 51.453442,
      lng: -2.590876
    },
    default_country_code: 'GB',
    default_map_pin: 'https://cdn.huggg.me/maps/default-map-pin.png',
    user_location_pin: 'https://cdn.huggg.me/maps/user-location-icon-animated5.svg',
    user_location_no_direction_pin: 'https://cdn.huggg.me/maps/user-location-icon-no-arrow-animated.svg',
    geolocation_timeout_ms: 1000
  };
  var styles = {
    popupTipAnchor: {
      height: 0,
      width: '200px',
      position: 'absolute'
    },
    popupBubbleAnchor: {
      width: '100%',
      position: 'absolute'
    },
    popupBubbleContent: {
      transform: 'translate(35px, -70px)',
      position: 'absolute',
      backgroundColor: 'white',
      padding: '12px',
      borderRadius: '5px',
      fontFamily: 'sans-serif',
      overflowY: 'auto',
      boxShadow: '0px 2px 10px 1px rgba(0,0,0,0.5)',
      display: 'none'
    }
  };
  function addStyles(el, styles) {
    Object.keys(styles).forEach(function (key) {
      el.style[key] = styles[key];
    });
  }
  function init(maps) {
    function Popup(position, content) {
      this.position = position;
      this.content = content;
      this.pixelOffset = document.createElement('div');
      this.anchor = document.createElement('div');
      this.pixelOffset.appendChild(this.content);
      this.anchor.appendChild(this.pixelOffset);
      addStyles(this.content, styles.popupBubbleContent);
      addStyles(this.pixelOffset, styles.popupBubbleAnchor);
      addStyles(this.anchor, styles.popupTipAnchor);
      this.stopEventPropagation();
      return this;
    }
    Popup.prototype = Object.create(maps.OverlayView.prototype);
    Popup.prototype.show = function () {
      this.anchor.style.display = 'block';
      this.content.style.display = 'block';
    };
    Popup.prototype.hide = function () {
      this.anchor.style.display = 'none';
      this.content.style.display = 'none';
    };
    Popup.prototype.remove = function () {
      this.setMap(null);
    };
    Popup.prototype.onAdd = function () {
      this.getPanes().floatPane.appendChild(this.anchor);
    };
    Popup.prototype.onRemove = function () {
      if (this.anchor.parentElement) {
        this.anchor.parentElement.removeChild(this.anchor);
      }
    };
    Popup.prototype.draw = function () {
      var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
      this.anchor.style.left = divPosition.x + 'px';
      this.anchor.style.top = divPosition.y + 'px';
    };
    Popup.prototype.stopEventPropagation = function () {
      var anchor = this.anchor;
      anchor.style.cursor = 'auto';
      ['click', 'dblclick', 'contextmenu', 'wheel', 'mousedown', 'touchstart', 'pointerdown'].forEach(function (event) {
        anchor.addEventListener(event, function (e) {
          e.stopPropagation();
        });
      });
    };
    return Popup;
  }
  var afterNextPaint = function afterNextPaint(fn) {
    return window.requestAnimationFrame(function () {
      return window.requestAnimationFrame(fn);
    });
  };
  var boundsFromLiteral = function boundsFromLiteral(bounds) {
    return new window.google.maps.LatLngBounds(new window.google.maps.LatLng(bounds.west, bounds.south), new window.google.maps.LatLng(bounds.east, bounds.north));
  };
  var boundsToLiteral = function boundsToLiteral(bounds) {
    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();
    return {
      north: ne.lng(),
      east: ne.lat(),
      south: sw.lng(),
      west: sw.lat()
    };
  };
  var coordsFromLiteral = function coordsFromLiteral(coords) {
    return new window.google.maps.LatLng(coords.lat, coords.lng);
  };
  var coordsFromUserLocation = function coordsFromUserLocation(_ref) {
    var coords = _ref.coords;
    return {
      lat: coords.latitude,
      lng: coords.longitude
    };
  };
  var coordsToLiteral = function coordsToLiteral(coords) {
    return {
      lat: coords.lat(),
      lng: coords.lng()
    };
  };
  var getZoomFromDevicePixelWidth = function getZoomFromDevicePixelWidth(latitude) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1609.344;
    var screenWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : window.innerWidth;
    return Math.round(Math.abs(Math.log2(distance / screenWidth / (156543.03392 * Math.cos(latitude * Math.PI / 180)))));
  };
  var locationImage = function locationImage(location) {
    return location.image_url ? location.image_url : appConfig.default_map_pin;
  };
  var getDescription = function getDescription(location) {
    if (location.description_markdown) {
      return marked(location.description_markdown);
    } else if (location && location.brand && location.brand.default_location_description_markdown) {
      return marked(location.brand.default_location_description_markdown);
    }
    return location.description ? "<p style=\"margin: 10px 0 0\">".concat(location.description, "</p>") : '';
  };
  var overlayContent = function overlayContent(location) {
    return ["<h5 style=\"margin: 0; font-size: 12px;\">".concat(location.name, "</h5>"), getDescription(location)].join('\n');
  };
  var overlay = function overlay(location) {
    var el = document.createElement('div');
    el.innerHTML = overlayContent(location);
    return el;
  };
  var panToOffset = function panToOffset(Gmaps, map) {
    return function (latlng, offsetx, offsety) {
      if (offsetx === 0 && offsety === 0) {
        map.panTo(latlng);
        return;
      }
      var scale = Math.pow(2, map.getZoom());
      var worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
      var pixelOffset = new Gmaps.Point(offsetx / scale || 0, offsety / scale || 0);
      var worldCoordinateNewCenter = new Gmaps.Point(worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);
      var newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);
      map.panTo(newCenter);
    };
  };
  var ACTIVE_MARKER_SCALING_FACTOR = 1.2;
  var BOUNCE_DURATION = 500;
  var HugggMarkers = function () {
    function HugggMarkers(Gmaps, map) {
      var _this = this;
      _classCallCheck(this, HugggMarkers);
      _defineProperty(this, "_createMarkerClickHandler", function (marker) {
        return function (options) {
          var defaultOptions = {
            center: true,
            highlight: true,
            popup: true
          };
          var _defaultOptions$optio = _objectSpread2(_objectSpread2({}, defaultOptions), options),
            center = _defaultOptions$optio.center,
            highlight = _defaultOptions$optio.highlight,
            popup = _defaultOptions$optio.popup;
          var markerPopup;
          _this.deactivateMarker();
          _this.currentMarker = marker.huggg_location.id;
          if (popup) {
            markerPopup = _this._showPopupfor(marker);
          }
          if (center) {
            _this._centerMarker(marker, markerPopup);
          }
          if (highlight) {
            marker.setZIndex(_this._maps.Marker.MAX_ZINDEX + 1);
            _this._scaleMarker(marker, ACTIVE_MARKER_SCALING_FACTOR);
            _this._bounceMarker(marker);
          }
          _this.deactivateMarker = function () {
            marker.setZIndex();
            _this._scaleMarker(marker, 1);
            if (markerPopup) {
              markerPopup.hide();
              markerPopup.remove();
            }
            _this.currentMarker = null;
          };
        };
      });
      _defineProperty(this, "_validateLocations", function (locations) {
        if (locations && locations.constructor === Array) {
          return true;
        }
        return false;
      });
      _defineProperty(this, "_validateMarkers", function (markers) {
        if (markers && markers.constructor === Array) {
          return true;
        }
        return false;
      });
      _defineProperty(this, "_showPopupfor", function (marker) {
        var popup = new _this._Popup(marker.getPosition(), overlay(marker.huggg_location));
        popup.setMap(_this._map);
        popup.show(marker.getPosition());
        return popup;
      });
      _defineProperty(this, "_scaleMarker", function (marker, scaleFactor) {
        var scaled = new _this._maps.Size(_this._options.pinWidth * scaleFactor, _this._options.pinHeight * scaleFactor);
        marker.icon.scaledSize = scaled;
        marker.icon.size = scaled;
        marker.icon.anchor = new _this._maps.Point(_this._options.pinWidth * scaleFactor / 2, _this._options.pinHeight * scaleFactor);
      });
      _defineProperty(this, "_bounceMarker", function (marker) {
        marker.setAnimation(_this._maps.Animation.BOUNCE);
        window.setTimeout(function () {
          return marker.setAnimation(null);
        }, BOUNCE_DURATION);
      });
      _defineProperty(this, "_centerMarker", function (marker, popup) {
        var position = marker.getPosition();
        _this._map.panTo(position);
        if (popup) {
          afterNextPaint(function () {
            var offset = _this._calculateOffset(popup);
            _this._panToOffset(position, offset);
          });
        }
      });
      _defineProperty(this, "_calculateOffset", function (popup) {
        var width = popup.content.offsetWidth;
        return -1 * (width / 2);
      });
      this._options = {
        pinWidth: 80,
        pinHeight: 80,
        clickablePinArea: [40, 80, 16, 40, 40, 20, 64, 40]
      };
      this._maps = Gmaps;
      this._map = map;
      this._Popup = init(Gmaps);
      this._Clusterer = new MarkerClusterer(this._map, [], clusterOptions);
      this._markers = [];
      this.deactivateMarker = function () {
        return undefined;
      };
      this.currentMarker = null;
      this._map.addListener('click', function () {
        _this.deactivateMarker();
      });
      this._panToOffset = panToOffset(this._maps, this._map);
    }
    return _createClass(HugggMarkers, [{
      key: "markers",
      get: function get() {
        return this._markers;
      }
    }, {
      key: "addMarkers",
      value: function addMarkers(locations, clickHandler) {
        var _this2 = this;
        if (!this._validateLocations(locations)) {
          throw new InvalidLocationsError(InvalidLocationsError.defaultMessage);
        }
        var newMarkers = locations.reduce(function (acc, location) {
          location.zIndex = acc.count;
          acc.markers.push(_this2._locationToMarker(location));
          acc.count += 1;
          return acc;
        }, {
          count: 0,
          markers: []
        });
        newMarkers = this._addMarkerListeners(newMarkers.markers, clickHandler);
        this._markers = this._markers.concat(newMarkers);
      }
    }, {
      key: "removeMarkers",
      value: function removeMarkers(markers) {
        if (!this._validateLocations(markers)) {
          throw new InvalidMarkersError(InvalidMarkersError.defaultMessage);
        }
        var ids = markers.map(function (item) {
          return item.huggg_location.id;
        });
        if (ids.includes(this.currentMarker)) {
          this.deactivateMarker();
        }
        markers.forEach(function (marker) {
          return marker.setMap(null);
        });
        this._markers = this._markers.filter(function (item) {
          return !ids.includes(item.huggg_location.id);
        });
      }
    }, {
      key: "clearMarkers",
      value: function clearMarkers() {
        return this.removeMarkers(this._markers);
      }
    }, {
      key: "refreshClusterer",
      value: function refreshClusterer() {
        this._Clusterer.clearMarkers();
        this._Clusterer.addMarkers(this._markers);
      }
    }, {
      key: "updateMarkers",
      value: function updateMarkers(locations, clickHandler) {
        if (!this._validateLocations(locations)) {
          throw new InvalidLocationsError(InvalidLocationsError.defaultMessage);
        }
        var locationIds = locations.map(function (item) {
          return item.id;
        });
        var currentMarkers = this._markers.map(function (item) {
          return item.huggg_location.id;
        });
        var markersToAdd = locations.filter(function (item) {
          return !currentMarkers.includes(item.id);
        });
        var markersToRemove = this._markers.filter(function (item) {
          return !locationIds.includes(item.huggg_location.id);
        });
        this.removeMarkers(markersToRemove);
        this.addMarkers(markersToAdd, clickHandler);
        this.refreshClusterer();
      }
    }, {
      key: "_addMarkerListeners",
      value: function _addMarkerListeners(markers, customClickHandler) {
        var _this3 = this;
        return markers.map(function (marker) {
          var fallbackHandler = _this3._createMarkerClickHandler(marker);
          var clickHandler = customClickHandler ? function (event) {
            return customClickHandler(event, marker, fallbackHandler);
          } : function () {
            return fallbackHandler();
          };
          marker.addListener('click', clickHandler);
          return marker;
        });
      }
    }, {
      key: "_createIcon",
      value: function _createIcon(location) {
        return {
          url: locationImage(location),
          scaledSize: new this._maps.Size(this._options.pinWidth, this._options.pinHeight),
          origin: new this._maps.Point(0, 0),
          anchor: new this._maps.Point(this._options.pinWidth / 2, this._options.pinHeight)
        };
      }
    }, {
      key: "_getLocationMarkerImage",
      value: function _getLocationMarkerImage() {
        if (!this._locationMarkerImage) {
          var locationMarkerImage = document.querySelector("img[src=\"".concat(appConfig.user_location_pin, "\"]"));
          if (locationMarkerImage) {
            locationMarkerImage.style.transformOrigin = "center";
            this._locationMarkerImage = locationMarkerImage;
          }
        }
        return this._locationMarkerImage;
      }
    }, {
      key: "_locationToMarker",
      value: function _locationToMarker(location) {
        var marker = new this._maps.Marker({
          icon: this._createIcon(location),
          shape: {
            coords: this._options.clickablePinArea,
            type: 'poly'
          },
          position: {
            lat: parseFloat(location.latitiude),
            lng: parseFloat(location.longitude)
          },
          zIndex: location.zIndex
        });
        marker.huggg_location = location;
        return marker;
      }
    }]);
  }();
  var HugggMapRequestBounds = function () {
    function HugggMapRequestBounds(GMaps, mapInstance, options) {
      _classCallCheck(this, HugggMapRequestBounds);
      this._defaults = {
        factorX: 3,
        factorY: 3
      };
      this._maps = GMaps;
      this._map = mapInstance;
      this._options = _objectSpread2(_objectSpread2({}, this._defaults), options);
      this._Dispatcher = new barStaff.Dispatcher();
      this._registerEventListeners();
      this._currentBoundingBox = {
        north: 0,
        east: 0,
        south: 0,
        west: 0
      };
    }
    return _createClass(HugggMapRequestBounds, [{
      key: "addListener",
      value: function addListener(callback) {
        this._validateListener(callback);
        this._Dispatcher.on('requestBoundsChanged', callback);
      }
    }, {
      key: "forceUpdateBoundingBox",
      value: function forceUpdateBoundingBox() {
        this._currentBoundingBox = this._calculateBoundsThreshold();
      }
    }, {
      key: "removeListener",
      value: function removeListener(callback) {
        this._validateListener(callback);
        this._Dispatcher.off('requestBoundsChanged', callback);
      }
    }, {
      key: "_calculateBoundsThreshold",
      value: function _calculateBoundsThreshold() {
        var bounds = this._getCurrentMapBounds();
        var y = bounds.north - bounds.south;
        var x = bounds.east - bounds.west;
        var expanded = {
          x: x * this._options.factorX,
          y: y * this._options.factorY
        };
        return {
          north: bounds.north + expanded.y,
          east: bounds.east + expanded.x,
          south: bounds.south - expanded.y,
          west: bounds.west - expanded.x
        };
      }
    }, {
      key: "_getCurrentMapBounds",
      value: function _getCurrentMapBounds() {
        return boundsToLiteral(this._map.getBounds());
      }
    }, {
      key: "_registerEventListeners",
      value: function _registerEventListeners() {
        var _this = this;
        var events = ['dragend', 'zoom_changed'];
        events.forEach(function (eventName) {
          _this._map.addListener(eventName, function () {
            var shouldFetch = _this._shouldFetchData(_this._getCurrentMapBounds());
            _this._Dispatcher.dispatch('requestBoundsChanged', {
              shouldFetch: shouldFetch,
              bounds: _this._getCurrentMapBounds(),
              extendedBounds: _this._currentBoundingBox
            });
          });
        });
      }
    }, {
      key: "_shouldFetchData",
      value: function _shouldFetchData(bounds) {
        var boundsWidth = Math.abs(bounds.east - bounds.west);
        var boundsHeight = Math.abs(bounds.north - bounds.south);
        var edgeEast = Math.abs(this._currentBoundingBox.east - bounds.east);
        var edgeWest = Math.abs(this._currentBoundingBox.west - bounds.west);
        var edgeNorth = Math.abs(this._currentBoundingBox.north - bounds.north);
        var edgeSouth = Math.abs(this._currentBoundingBox.south - bounds.south);
        var shouldFetch = edgeEast < boundsWidth || edgeWest < boundsWidth || edgeNorth < boundsHeight || edgeSouth < boundsHeight;
        if (shouldFetch) {
          this._currentBoundingBox = this._calculateBoundsThreshold();
        }
        return shouldFetch;
      }
    }, {
      key: "_validateListener",
      value: function _validateListener(callback) {
        if (!callback) {
          throw new InvalidBoundsError$1('Parameter "callback" is a required parameter.');
        }
        if (callback.constructor !== Function) {
          throw new InvalidBoundsError$1("Invalid \"eventName\", expected type {Function} but {".concat(callback.constructor.name, "} supplied."));
        }
      }
    }]);
  }();
  var ExtendsUserLocationOverlay = function _target() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$SuperClass = _ref.SuperClass,
      SuperClass = _ref$SuperClass === void 0 ? window.google.maps.OverlayView : _ref$SuperClass,
      map = _ref.map;
    if (!(this instanceof _target ? this.constructor : void 0)) {
      throw new Error("Uncaught TypeError: Class constructor ExtendsFetcher cannot be invoked without 'new'");
    }
    var UserLocationOverlay = function (_SuperClass) {
      function UserLocationOverlay(map) {
        var _this;
        _classCallCheck(this, UserLocationOverlay);
        _this = _callSuper(this, UserLocationOverlay);
        _this._coords = null;
        _this._div = null;
        _this._map = map;
        _this._orientationAlpha = 0;
        _this._Dispatcher = new barStaff.Dispatcher();
        _this._MobileDetect = new MobileDetect(window.navigator.userAgent);
        try {
          _this.setMap(map);
        } catch (err) {
          console.error(err);
        }
        return _this;
      }
      _inherits(UserLocationOverlay, _SuperClass);
      return _createClass(UserLocationOverlay, [{
        key: "coords",
        get: function get() {
          return this._coords;
        }
      }, {
        key: "draw",
        value: function draw() {
          if (!this._coords) {
            return;
          }
          var div = this._div;
          var size = 48;
          var overlayProjection = this.getProjection();
          var position = overlayProjection.fromLatLngToDivPixel(new window.google.maps.LatLng(this._coords.lat, this._coords.lng));
          div.style.opacity = 1;
          div.style.transform = "translate(".concat(position.x - size / 2, "px, ").concat(position.y - size / 2, "px)");
          this._Dispatcher.dispatch('updated', {
            coordinates: this._coords
          });
        }
      }, {
        key: "onAdd",
        value: function onAdd() {
          var _this2 = this;
          var panes = this.getPanes();
          var div = this._createDiv();
          var img = this._createImg();
          var size = 48;
          div.appendChild(img);
          panes.overlayImage.appendChild(div);
          div.style.height = "".concat(size, "px");
          div.style.left = 0;
          div.style.top = 0;
          div.style.width = "".concat(size, "px");
          div.style.opacity = 0;
          this._div = div;
          this._img = img;
          this._watchOrientation();
          barStaff.getCurrentDeviceLocation({
            timeout: Infinity
          }).then(function () {
            _this2._watchLocation();
          });
          this._Dispatcher.dispatch('created', {
            div: div,
            img: img
          });
        }
      }, {
        key: "onRemove",
        value: function onRemove() {
          this.stopOrientationListener();
          this.stopLocationListener();
          this._div.parentNode.removeChild(this._div);
          this._div = null;
        }
      }, {
        key: "addListener",
        value: function addListener(eventName, callback) {
          this._validateListener(eventName, callback);
          this._Dispatcher.on(eventName, callback);
        }
      }, {
        key: "addListenerOnce",
        value: function addListenerOnce(eventName, callback) {
          var _this3 = this;
          this._validateListener(eventName, callback);
          var _newCallback = function newCallback(data) {
            _this3.removeListener(eventName, _newCallback);
            callback(data);
          };
          this.addListener(eventName, _newCallback);
        }
      }, {
        key: "removeListener",
        value: function removeListener(eventName, callback) {
          this._validateListener(eventName, callback);
          this._Dispatcher.off(eventName, callback);
        }
      }, {
        key: "setPosition",
        value: function setPosition(coords) {
          this._validateCoordinates(coords);
          this._coords = coords;
          this.draw();
        }
      }, {
        key: "setVisible",
        value: function setVisible(visible) {
          var cssVisbility = visible ? 'visible' : 'hidden';
          if (this._div && visible !== this._visible) {
            this._div.style.visibility = cssVisbility;
          }
          this._visible = visible;
        }
      }, {
        key: "stopOrientationListener",
        value: function stopOrientationListener() {
          if (this.deviceOrientation) {
            this.deviceOrientation.clear();
          }
        }
      }, {
        key: "stopLocationListener",
        value: function stopLocationListener() {
          if (this.deviceLocation) {
            this.deviceLocation.stop();
          }
        }
      }, {
        key: "_createDiv",
        value: function _createDiv() {
          var div = document.createElement('div');
          div.style.border = 'none';
          div.style.borderWidth = '0px';
          div.style.position = 'absolute';
          div.style.zIndex = 1000;
          return div;
        }
      }, {
        key: "_createImg",
        value: function _createImg() {
          var img = document.createElement('img');
          var imgUrl = barStaff.supportsOrientationEvent && this._MobileDetect.mobile() ? appConfig.user_location_pin : appConfig.user_location_no_direction_pin;
          img.src = imgUrl;
          img.style.width = '100%';
          img.style.height = '100%';
          img.style.transformOrigin = "center";
          return img;
        }
      }, {
        key: "_setIconOrientation",
        value: function _setIconOrientation() {
          var deg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          this._img.style.transform = "rotate(".concat(deg, "deg)");
        }
      }, {
        key: "_validateCoordinates",
        value: function _validateCoordinates(coordinates) {
          if (!coordinates.lat || !coordinates.lng) {
            throw new InvalidCoordinatesError(InvalidCoordinatesError.defaultMessage);
          }
        }
      }, {
        key: "_validateListener",
        value: function _validateListener(eventName, callback) {
          if (!eventName) {
            throw new InvalidBoundsError$1('Parameter "eventName" is a required parameter.');
          }
          if (!callback) {
            throw new InvalidBoundsError$1('Parameter "callback" is a required parameter.');
          }
          if (eventName.constructor !== String) {
            throw new InvalidBoundsError$1("Invalid \"eventName\", expected type {String} but {".concat(eventName.constructor.name, "} supplied."));
          }
          if (callback.constructor !== Function) {
            throw new InvalidBoundsError$1("Invalid \"eventName\", expected type {Function} but {".concat(callback.constructor.name, "} supplied."));
          }
        }
      }, {
        key: "_watchLocation",
        value: function _watchLocation() {
          var _this4 = this;
          if (this.deviceLocation) {
            return;
          }
          this.deviceLocation = barStaff.watchDeviceLocation();
          this.deviceLocation.start(function (coords) {
            _this4.setPosition(coordsFromUserLocation(coords));
          });
        }
      }, {
        key: "_watchOrientation",
        value: function _watchOrientation() {
          var _this5 = this;
          if (this.deviceOrientation) {
            return;
          }
          this.deviceOrientation = barStaff.getDeviceOrientation();
          this.deviceOrientation.listen(function (newAlpha) {
            if (newAlpha !== _this5._orientationAlpha) {
              _this5._setIconOrientation(-newAlpha);
              _this5._orientationAlpha = newAlpha;
            }
          });
        }
      }]);
    }(SuperClass);
    return new UserLocationOverlay(map);
  };
  var HugggMap = function () {
    function HugggMap(Gmaps, map) {
      var _this = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      _classCallCheck(this, HugggMap);
      _defineProperty(this, "addListener", function (eventName, callback) {
        return _this._map.addListener(eventName, callback);
      });
      _defineProperty(this, "addRequestBoundsListener", function (callback) {
        _this._HugggMapRequestBounds.addListener(callback);
      });
      _defineProperty(this, "clearListeners", function (eventName) {
        return _this._maps.event.clearListeners(_this._map, eventName);
      });
      _defineProperty(this, "detachFromDOM", function () {
        if (_this._mapDOMElement.parentNode) {
          _this._mapDOMElement.parentNode.removeChild(_this._mapDOMElement);
        }
      });
      _defineProperty(this, "displayUserLocation", function () {
        var panToPosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return _this._userLocationMarker ? Promise.resolve(_this._userLocationMarker.coords) : _this._createUserLocationOverlay(panToPosition);
      });
      _defineProperty(this, "removeUserLocation", function () {
        if (_this._userLocationMarker) {
          _this._userLocationMarker.setMap(null);
          _this._userLocationMarker = null;
        }
      });
      _defineProperty(this, "fitBounds", function (bounds) {
        _this._validateBounds(bounds);
        return _this._map.fitBounds(boundsFromLiteral(bounds));
      });
      _defineProperty(this, "getBounds", function () {
        return boundsToLiteral(_this._map.getBounds());
      });
      _defineProperty(this, "getCenter", function () {
        return coordsToLiteral(_this._map.getCenter());
      });
      _defineProperty(this, "getZoom", function () {
        return _this._map.getZoom();
      });
      _defineProperty(this, "getZoomFromDevicePixelWidth", function (lat, distance) {
        return getZoomFromDevicePixelWidth(lat, distance);
      });
      _defineProperty(this, "panToPosition", function (coords) {
        _this._validateCoordinates(coords);
        _this._map.panTo(coordsFromLiteral(coords));
      });
      _defineProperty(this, "reattachToDOM", function (selector) {
        if (_this._mapDOMElement.parentNode) {
          _this._mapDOMElement.parentNode.removeChild(_this._mapDOMElement);
        }
        barStaff.getDomElement(selector).appendChild(_this._mapDOMElement);
      });
      _defineProperty(this, "removeListener", function (listener) {
        return _this._maps.event.removeListener(listener);
      });
      _defineProperty(this, "removeRequestBoundsListener", function (callback) {
        _this._HugggMapRequestBounds.removeListener(callback);
      });
      _defineProperty(this, "resetToUserLocation", function () {
        if (_this._userLocationMarker && _this._userLocationMarker.coords) {
          var coordinates = _this._userLocationMarker.coords;
          var zoom = _this.getZoomFromDevicePixelWidth(coordinates.lat);
          _this.setZoom(zoom);
          _this.panToPosition(coordinates);
        }
      });
      _defineProperty(this, "setZoom", function (zoom) {
        _this._zoomFlag = 'api';
        _this._map.setZoom(zoom);
        _this._zoomFlag = 'user';
      });
      _defineProperty(this, "updatePurchaseLocationMarkers", function (locations) {
        var customClickHandler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        _this._locations = locations;
        return _this._HugggMarkers.updateMarkers(locations, customClickHandler);
      });
      _defineProperty(this, "_createUserLocationOverlay", function (panToPosition) {
        return new Promise(function (resolve) {
          var userLocationMarker = new ExtendsUserLocationOverlay({
            map: _this._map
          });
          var onUpdatedOnce = function onUpdatedOnce(_ref) {
            var coordinates = _ref.coordinates;
            if (!_this._touched && panToPosition) {
              _this.resetToUserLocation();
              _this._HugggMapRequestBounds.forceUpdateBoundingBox();
            }
            resolve(coordinates);
          };
          userLocationMarker.addListenerOnce('updated', onUpdatedOnce);
          _this._userLocationMarker = userLocationMarker;
        });
      });
      _defineProperty(this, "_clearStartupInteractionListeners", function () {
        _this._startupInteractionListeners.forEach(_this.removeListener);
      });
      _defineProperty(this, "_registerEventListeners", function () {
        var interactionEvents = ['click', 'dragstart', 'zoom_changed'];
        var isApiZoom = function isApiZoom(eventName) {
          return eventName === 'zoom_changed' && _this._zoomFlag === 'api' && !_this._touched;
        };
        interactionEvents.forEach(function (eventName) {
          var onEventFired = function onEventFired() {
            if (!isApiZoom(eventName)) {
              _this._touched = true;
              _this._clearStartupInteractionListeners();
            }
          };
          var listener = _this.addListener(eventName, onEventFired);
          _this._startupInteractionListeners.push(listener);
        });
      });
      _defineProperty(this, "_validateBounds", function (bounds) {
        if (!bounds) {
          throw new InvalidBoundsError('"bounds" is a required parameter.');
        }
        if (bounds.constructor !== Object) {
          throw new InvalidBoundsError("Expected \"bounds\" to be of type {Object}, but {".concat(bounds.constructor.name, "} was supplied."));
        }
        if (!bounds.north || !bounds.east || !bounds.south || !bounds.west) {
          throw new InvalidBoundsError(InvalidBoundsError.defaultMessage);
        }
      });
      _defineProperty(this, "_validateCoordinates", function (coordinates) {
        if (!coordinates) {
          throw new InvalidCoordinatesError('"coords" is a required parameter.');
        }
        if (coordinates.constructor !== Object) {
          throw new InvalidCoordinatesError("Expected \"coords\" to be of type {Object}, but {".concat(coordinates.constructor.name, "} was supplied."));
        }
        if (!coordinates.lat || !coordinates.lng) {
          throw new InvalidCoordinatesError(InvalidCoordinatesError.defaultMessage);
        }
      });
      var defaults = mapOptions;
      this._map = map;
      this._maps = Gmaps;
      this._startupInteractionListeners = [];
      this._mapDOMElement = map.getDiv();
      this._options = _objectSpread2(_objectSpread2({}, defaults), options);
      this._purchaseLocationMarkers = [];
      this._purchaseLocations = [];
      this._touched = false;
      this._userLocationMarker = null;
      this._zoomFlag = 'user';
      this._HugggMarkers = new HugggMarkers(Gmaps, map);
      this._HugggMapRequestBounds = new HugggMapRequestBounds(Gmaps, map);
      this._registerEventListeners();
    }
    return _createClass(HugggMap, null, [{
      key: "init",
      value: function init(Gmaps, selector) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : mapOptions;
        return new Promise(function (resolve) {
          var map = new Gmaps.Map(barStaff.getDomElement(selector), options);
          resolve(new HugggMap(Gmaps, map));
        });
      }
    }]);
  }();
  var formatResults = function formatResults(results) {
    var geometry = results.geometry;
    var bounds = geometry.bounds,
      location = geometry.location;
    return {
      bounds: bounds ? boundsToLiteral(bounds) : null,
      coords: location ? coordsToLiteral(location) : null
    };
  };
  var HugggLocationSearch = _createClass(function HugggLocationSearch(GMaps, restrictions) {
    var _this = this;
    _classCallCheck(this, HugggLocationSearch);
    _defineProperty(this, "search", function (searchTerm) {
      return new Promise(function (resolve, reject) {
        _this.placesAutocomplete.getPlacePredictions({
          componentRestrictions: _this.componentRestrictions,
          input: searchTerm
        }, function (results, status) {
          return status === 'OK' ? resolve(results) : reject(new Error('No results'));
        });
      });
    });
    _defineProperty(this, "getResultCoordinates", function (resultItem) {
      if (_this.lastSearchCoordinates && resultItem.place_id === _this.lastSearchCoordinates.place_id) {
        return Promise.resolve(formatResults(_this.lastSearchCoordinates));
      }
      return new Promise(function (resolve, reject) {
        _this.geocoder.geocode({
          placeId: resultItem.place_id
        }, function (results, status) {
          if (status === 'OK') {
            var first = results[0];
            _this.lastSearchCoordinates = first;
            return resolve(formatResults(first));
          }
          return reject(new Error("Couldnt't find the location: ".concat(resultItem.place_id)));
        });
      });
    });
    var defaultRestrictions = {
      country: 'GB'
    };
    this.componentRestrictions = _objectSpread2(_objectSpread2({}, defaultRestrictions), restrictions);
    this.maps = GMaps;
    this.geocoder = new GMaps.Geocoder();
    this.placesAutocomplete = new GMaps.places.AutocompleteService();
    this.lastSearchCoordinates = null;
  });
  var bounds = {
    GB: {
      north: 61.090886479,
      east: 2.1034487646,
      south: 49.6542911263,
      west: -11.0425901796
    }
  };
  var getPredefinedBounds = function getPredefinedBounds() {
    var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'all';
    if (location === 'all') {
      return bounds;
    }
    if (bounds[location]) {
      return bounds[location];
    }
    return null;
  };
  exports.HugggMap = HugggMap;
  exports.HugggMapRequestBounds = HugggMapRequestBounds;
  exports.HugggMapSearch = HugggLocationSearch;
  exports.HugggMarkers = HugggMarkers;
  exports.config = mapOptions;
  exports.default = HugggMap;
  exports.getPredefinedBounds = getPredefinedBounds;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});